import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import './selectize.css';
import '@selectize/selectize';

export default class SelectizeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.selectRef = createRef();
  }

  componentDidMount() {
    this._selectize();
    this._syncDisabledState();
  }

  // XXX: This component IS UNABLE TO REFRESH OPTIONS if they've been updated by our parent component
  // workaround: don't render it until you have the options. 5ux.
  // you can run but you can't hide: selectize fuxup with the DOM and keeps an internal state and it does not look at the original <select> element.
  // not even destroy() & reinit works, because it caches the initial options and restores them upon destroy(). Have fun!
  componentDidUpdate(prevProps) {
    const { value } = this.props;
    const selectNode = this._selectNode();
    if (prevProps.value !== value) {
      if (selectNode.selectize) {
        selectNode.selectize.setValue(value);
      }
    }
    this._syncDisabledState();
  }

  _selectNode() {
    return this.selectRef.current;
  }

  _syncDisabledState() {
    const { disabled } = this.props;
    const selectNode = this._selectNode();
    if (disabled && !selectNode.selectize.isDisabled) {
      selectNode.selectize.disable();
    } else if (!disabled && selectNode.selectize.isDisabled) {
      selectNode.selectize.enable();
    }
  }

  _selectize() {
    const { onChange, placeholder, value, selectizeOptions } = this.props;
    $(this.selectRef.current).selectize({
      onChange: (val) => {
        return onChange(val);
      },
      placeholder,
      value,
      ...selectizeOptions,
    });
  }

  _changed(e) {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(e.currentTarget.value);
  }

  _renderOptions() {
    const { options } = this.props;
    return options.map(this._renderOption);
  }

  _renderOption(option, index) {
    return (
      <option key={index} value={option.value}>
        {option.text}
      </option>
    );
  }

  _renderPlaceholder() {
    const { placeholder } = this.props;
    const option = {
      value: '',
      text: placeholder,
    };
    return this._renderOption(option, 0);
  }

  render() {
    const { className, dataTestId, placeholder, value } = this.props;
    return (
      <div className={`Select ${className || ''}`} data-testid={dataTestId}>
        <select
          ref={this.selectRef}
          className="Select-control"
          value={value}
          onChange={this._changed.bind(this)}
        >
          {placeholder ? this._renderPlaceholder() : null}
          {this._renderOptions()}
        </select>
      </div>
    );
  }
}

SelectizeSelect.displayName = 'SelectizeSelect';

SelectizeSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  selectizeOptions: PropTypes.object,
};

SelectizeSelect.defaultProps = {
  value: null,
  selectizeOptions: {},
  disabled: false,
};
